import React from 'react';

import { IngestionResourceAction } from '../../../../../../gamma-api';
import { getTranslateFunc } from '../../../../../utils/stringUtil';
import IbTag from '../../../../../components/common/IbTag';

import './index.less';

import { MAIN_CLASS_NAME } from './const';

export interface IResourceActionProps {
  action?: IngestionResourceAction;
}

const ResourceAction: React.FC<IResourceActionProps> = ({ action }) => {
  const translate = getTranslateFunc('Resource action:');

  const renderTag = () => {
    if (!action) {
      return <IbTag content={translate('None')} style="default" />;
    }

    if (action === IngestionResourceAction.Remain) {
      return <IbTag content={translate('Remain')} style="default" />;
    }

    if (action === IngestionResourceAction.Create) {
      return <IbTag content={translate('Create')} style="success" />;
    }

    if (action === IngestionResourceAction.Update) {
      return <IbTag content={translate('Update')} style="warning" />;
    }

    if (action === IngestionResourceAction.Delete) {
      return <IbTag content={translate('Delete')} style="error" />;
    }

    return <IbTag content={translate('Unknown')} style="default" />;
  };

  return <div className={MAIN_CLASS_NAME}>{renderTag()}</div>;
};

export default ResourceAction;
